import React from 'react';
import { Box, Typography, Chip, TextField } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const DataComparison = ({ 
  cin7Value, 
  shopifyValue, 
  label, 
  cin7Label = "Cin7", 
  shopifyLabel = "Shopify",
  isEditingMode = false,
  editValue,
  setEditValue,
  fieldName,
  hideLabel = false,
  autoFocus = false
}) => {
  const isMatch = cin7Value === shopifyValue;
  
  const isProductTitle = hideLabel && fieldName === 'productName'; 
  
  let statusColor = 'error';
  let statusLabel = 'Mismatch';
  
  if (isMatch) {
    statusColor = 'success';
    statusLabel = 'Match';
  }
  
  const labelStyle = { fontWeight: 600, fontSize: isProductTitle ? undefined : 12 };
  const valueStyle = { fontWeight: isProductTitle ? 700 : 500, fontSize: isProductTitle ? undefined : 14 };
  
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: 2, 
      p: 0.5, 
      borderRadius: 1,
      width: '100%',
    }}>
      {!hideLabel && (
        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 120, flexShrink: 0 }}>
          {label}:
        </Typography>
      )}
      
      {isEditingMode ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
          <TextField
            size="small"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            autoFocus={autoFocus}
            sx={{ 
              width: '100%',
              maxWidth: '100%',
              flex: 1,
              '& .MuiInputBase-input':isProductTitle ? {
                fontSize: '1.5rem',
                fontWeight: 700,
                width: '100%',
              } : {
                fontSize: 14,
              }
            }}
          />
        </Box>
      ) : (
        isMatch ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant={isProductTitle ? "h5" : "subtitle1"} sx={{ ...valueStyle, minWidth: 160, flex: 1 }}>
              {cin7Value || "-"}
            </Typography>
            <Chip
              icon={<CheckCircleIcon sx={{ color: 'success.main', fontSize: 1 }} />}
              label={statusLabel}
              color={statusColor}
              size="small"
              variant="filled"
            />

          </Box>
        ) : (
          <>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 120, flex: 1 }}>
                <Typography variant="caption" color="textSecondary" sx={labelStyle}>
                  {cin7Label}
                </Typography>
                <Typography variant={isProductTitle ? "h5" : "body2"} sx={valueStyle}>
                  {cin7Value || "-"}
                </Typography>
              </Box>
              
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 120, flex: 1 }}>
                <Typography variant="caption" color="textSecondary" sx={labelStyle}>
                  {shopifyLabel}
                </Typography>
                <Typography variant={isProductTitle ? "h5" : "body2"} sx={valueStyle}>
                  {shopifyValue || "-"}
                </Typography>
              </Box>
            </Box>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip
                icon={<CancelIcon sx={{ color: 'error.main' }} />}
                label={statusLabel}
                color={statusColor}
                size="small"
                variant="outlined"
              />
            </Box>
          </>
        )
      )}
    </Box>
  );
};

export default DataComparison;
